import { Modal } from 'react-bootstrap';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonDarkBlue, ButtonLightGrey } from '../../HouseStyle/Components/Buttons';
import { useState } from 'react';

const DeleteConfirmModal = ({ setDeleteModalVisible, deleteModalVisible, handleDelete }) => {
    const [deleting, setDeleting] = useState(false);

    return (
        <Modal
            id="modalBlueprint"
            show={deleteModalVisible}
            onHide={() => setDeleteModalVisible()}
            size="lg"
            centered
        >
            <Modal.Header className="modalTop justify-content-between">
                <h4 className='fw-bold'>Dit product verwijderen?</h4>
                <button variant="transparent" className=' btn' onClick={() => setDeleteModalVisible(false)}>
                    <FontAwesomeIcon icon={faXmark} className="closeModal" />
                </button>
            </Modal.Header>
            <Modal.Body className="modalCenter">
                <p className='FlatText'>Weet je zeker dat je dit product wilt verwijderen? Dit kan niet ongedaan worden.</p>
                <div className="contendModal d-flex flex-row gap-3">
                    <ButtonDarkBlue text="Ja, ik weet het zeker" disabled={deleting} onClickFunction={() => {
                        setDeleting(true);
                        handleDelete();
                    }} />
                    <ButtonLightGrey text="Annuleren" onClickFunction={() => setDeleteModalVisible(false)} />
                </div>
            </Modal.Body>
            <Modal.Footer className="modalBottom">
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteConfirmModal;